import type { FC } from 'react';

import StatValue from 'app/components/StatValue';

import style from './style.module.scss';

interface Props extends ClassNameProp {
  playerStats:
    | {
        kills?: number | null;
        assists?: number | null;
        deaths?: number | null;
      }
    | undefined;
}

const KDA: FC<Props> = ({ playerStats, className }) => (
  <span className={className}>
    <StatValue value={playerStats?.kills} />/
    <span className={style.deaths}>
      <StatValue value={playerStats?.deaths} />
    </span>
    /
    <StatValue value={playerStats?.assists} />
  </span>
);

KDA.displayName = 'KDA';

export default KDA;
